/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="24"
        height="12"
        viewBox="0 0 24 12"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M21.71 0h.14a1.16 1.16 0 0 1 .76.47l1.11 1.41a1.1 1.1 0 0 1 .27.83 1 1 0 0 1-.48.73l-4.6 3.42v5.13H0V2.11h18.48L19.97 1l1-.74a1.12 1.12 0 0 1 .88-.26ZM17.2 3.07H.99v8h16.93V7.63l-2.31 1.72-2.29.19v.79H8.7v-.95h3.12l1.3-3.22.11-.08ZM6.2 6.2l.7.67-1.45 1.4 1.45 1.4-.7.67-1.45-1.4-1.45 1.4-.7-.67 1.45-1.4-1.45-1.4.7-.67 1.45 1.39ZM21.7.95l-.1.06-7.7 5.72-.74 1.84 2.07-.16 7.66-5.7s.06-.05.06-.07a.27.27 0 0 0-.07-.14l-1.12-1.4a.23.23 0 0 0-.06-.15Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'CheckbookIcon';

export default Icon;
